import type { ApiLicenseeHistoryRecord } from '@pn/services/api/intel/types';
import { pnApiClient } from '@pn/services/api/pnApiClient';

const requestWellLicenseeHistory = async (wellIdentifier: string) => {
  return pnApiClient.request<ApiLicenseeHistoryRecord[]>({
    url: `v1/wells/${wellIdentifier}/license_history`,
  });
};

export const apiWellLicenseeHistoryProvider = {
  getWellLicenseeHistory: requestWellLicenseeHistory,
};
